// FeedMark uses its own embed script: in edit mode, an app page is a host page. The
// submissions go to the user of OWN_EMBED_KEY. Without the key, the embed script has no endpoint:
// the reviewer gets the JSON as text to copy. Thus production must have the key.
import { client } from "./api";

async function loadEmbed() {
  const config = await (await client.api.config.$get()).json();
  // The app pages are a public demo: the "Edit this page" links have `?feedmark=edit`, not the
  // edit key. The embed script needs the edit key of the domain of the app, for the user of OWN_EMBED_KEY.
  const url = new URL(location.href);
  if (config.ownEditKey && url.searchParams.get("feedmark") === "edit") {
    url.searchParams.set("feedmark", config.ownEditKey);
    history.replaceState(history.state, "", url);
  }
  const script = document.createElement("script");
  script.src = "/embed.js";
  if (config.embedEndpoint) script.dataset.endpoint = config.embedEndpoint;
  document.body.append(script);
}

// The same condition as the embed script (`apps/embed/src/embed.ts`): the parameter, the tool
// in sessionStorage, or the edit key in localStorage. Thus the page loads the script only for edit mode.
function inEditMode(): boolean {
  if (new URLSearchParams(location.search).has("feedmark")) return true;
  try {
    return sessionStorage.getItem("feedmark:tool") !== null || localStorage.getItem("feedmark:edit-key") !== null;
  } catch {
    return false;
  }
}

if (inEditMode()) {
  loadEmbed().catch(() => {
    // The page continues without edit mode.
  });
}
